import FormField from 'components/FormField';
import { FV } from './share';
import { useTranslate } from '@tolgee/react';
import { Input } from 'antd';
import useCrud from 'hooks/useCrud';
import { useMount } from 'ahooks';
import { useFormikContext } from 'formik';
import { taskList } from 'views/Todo/service';
import { useOrgConfigStateValue } from 'hooks/business/useOrgConfig';

const nameLimitLength = 30;

function Name() {
  const { t } = useTranslate();

  const { whiteListConfig: { AIDE_REMOVE_TASK } = {} } = useOrgConfigStateValue();

  const {
    values: { id },
  } = useFormikContext<FV>();

  const { list, fetchList } = useCrud({
    readList: () => taskList().then((res) => res),
  });

  useMount(() => {
    fetchList().catch(() => {});
  });

  return (
    <FormField<FV['name']>
      required
      name="name"
      label={AIDE_REMOVE_TASK ? t('marketing.策略名称') : t('marketing.任务名称')}
      validate={(value) => {
        if (!value || !value.trim()) {
          return AIDE_REMOVE_TASK ? t('marketing.请输入策略名称') : t('marketing.请输入任务名称');
        }

        if (list?.some((_) => _.name === value && _.id !== id)) {
          return AIDE_REMOVE_TASK ? t('marketing.策略名称已存在') : t('marketing.任务名称已存在');
        }
      }}
    >
      {({ field }) => {
        return (
          <Input
            placeholder={
              AIDE_REMOVE_TASK ? t('marketing.请输入策略名称') : t('marketing.请输入任务名称')
            }
            showCount
            maxLength={nameLimitLength}
            {...field}
            style={{ width: '570px' }}
          />
        );
      }}
    </FormField>
  );
}

export default Name;
